import { singleDeviceHeaderTypes } from "../actions/singleDeviceHeader";
import { authTypes } from "../actions/auth";

const initialState = {
  currentId: "",
  isBLE: null,
  isLoading: false,
  data: [],
  bleAttributes: [],
  gatewayAttributes: [],
  error: "",
};

const singleDeviceHeaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case singleDeviceHeaderTypes.FETCH_DEVICE_REQUEST:
      return {
        ...state,
        isLoading: true,
        currentId: action.payload.id,
        // Reset device-specific state when switching to a different device
        ...(state.currentId !== action.payload.id && {
          isBLE: null,
          bleAttributes: [],
          gatewayAttributes: [],
          data: [],
        }),
      };
    case singleDeviceHeaderTypes.FETCH_DEVICE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isBLE: action.payload.isBLE,
        data: action.payload.deviceData,
        bleAttributes: action.payload.bleAttributes,
        gatewayAttributes: action.payload.gatewayAttributes,
        error: null,
      };
    case singleDeviceHeaderTypes.FETCH_DEVICE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case authTypes.LOGOUT:
    case authTypes.AUTO_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default singleDeviceHeaderReducer;
